import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastService } from '@targx/services/toast/toast.service';
import { TxToastComponent } from './tx-toast.component';

@Component({
  selector: 'tx-toast-container',
  template: `
    <div class="fixed top-4 right-4 z-[9999] flex flex-col gap-3 pointer-events-none">
      @for (toast of toastService.toasts(); track toast.id) {
        <div class="pointer-events-auto">
          <tx-toast
            [toast]="toast"
            (dismissed)="toastService.dismiss(toast.id!)">
          </tx-toast>
        </div>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TxToastComponent],
})
export class TxToastContainerComponent {
  readonly toastService = inject(ToastService);
}
